import { AdData } from '../../../../../../services';
import { DataFieldToDisplay } from '../../../../types/data-field-to-display';
import { flattenObject } from '../../../../helpers/flatten-object';

export const convertDataFieldValueToString = (offer: AdData, field: DataFieldToDisplay): string => {
  return flattenObject(offer)?.[field.value as keyof AdData]?.toString() || '';
};
